import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

class PenalidadesDadosGeraisApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async buscarOrgaosSancionadoresPenalidade({ idPessoa, idEntidade, tipo, idAta }) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.urlBuilder.dadosGerais.getUrlBuscarOrgaosSancionadoresPenalidade(),
			filters: { idPessoa, idEntidade, tipo: tipo.value, idAta },
		}).build()

		return await axios.get(url)
	}
	async buscarFornecedoresPenalidade({ tipo, idEntidade, idAta }) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.urlBuilder.dadosGerais.getUrlBuscarFornecedoresPenalidade(),
			filters: { idEntidade, tipo: tipo.value, idAta },
		}).build()

		return await axios.get(url)
	}
	async buscarTiposPenalidade({ idEntidade, tipoPenalidade }) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.urlBuilder.dadosGerais.getUrlBuscarTiposPenalidade(idEntidade),
			filters: { tipoPenalidade },
		}).build()

		return await axios.get(url)
	}
	async salvarDadosGeraisPenalidade(obj) {
		return await axios.post(this.urlBuilder.dadosGerais.getUrlSalvarDadosGeraisPenalidade(), {
			...obj,
			tipo: obj.tipo.value,
		})
	}
	async buscarDadosGeraisPenalidade({ idPenalidade }) {
		return await axios.get(this.urlBuilder.dadosGerais.getUrlBuscarDadosGeraisPenalidade(idPenalidade))
	}
}

export default PenalidadesDadosGeraisApiClient
